var _rect, _rect2, _rect3, _rect4, _circle;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnils(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 44,
    viewBox: "0 0 64 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 42,
    rx: 5,
    stroke: "#2C2D2E",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 21.317,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 15.767,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 13,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 28,
    r: 6,
    stroke: "#2C2D2E",
    strokeWidth: 2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA2NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjYyIiBoZWlnaHQ9IjQyIiByeD0iNSIgc3Ryb2tlPSIjMkMyRDJFIiBzdHJva2Utd2lkdGg9IjIiLz4KPHJlY3QgeD0iMTAiIHk9IjEwIiB3aWR0aD0iMjEuMzE2NSIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iIzJDMkQyRSIvPgo8cmVjdCB4PSIxMCIgeT0iMTYiIHdpZHRoPSIxNS43Njc0IiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjMkMyRDJFIi8+CjxyZWN0IHg9IjEwIiB5PSIyMiIgd2lkdGg9IjEzIiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjMkMyRDJFIi8+CjxjaXJjbGUgY3g9IjQ3IiBjeT0iMjgiIHI9IjYiIHN0cm9rZT0iIzJDMkQyRSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";
export { SvgSnils as ReactComponent };